module.exports = __webpack_public_path__ + "img/icon48.ba03aea1.png";